import { CliAutocompleteOption, EventQueueView } from '@mark43/cad-api';
import { normalizeEventNumber } from '../event-autocomplete/local-first-event-autocomplete';

/**
 * Map an active event queue view to the same `CliAutocompleteOption` shape the server returns
 * for the EVENT argument (see CliAutocompleteService.agencyEventToCliAutocompleteOption).
 * Events in the DISPATCH queue map are always active — cleared events only arrive via the
 * server — so `isActive` is always true here.
 */
export function eventQueueViewToCliAutocompleteOption(
    eventQueueView: EventQueueView
): CliAutocompleteOption {
    const eventNumber = normalizeEventNumber(eventQueueView.eventNumber);
    return {
        title: eventNumber,
        value: eventQueueView.id,
        segmentText: `#${eventNumber}`,
        cliArgument: 'EVENT',
        subtitle: eventQueueView.cfsNumberAndText,
        eventDetails: { isActive: true },
    };
}

export const getCliAutocompleteOptionEventId = (option: CliAutocompleteOption): number =>
    option.value;
